import { useCallback } from 'react';
import { dispatcher } from 'dispatcher';
import { prop } from 'ramda';
import { useNavigate } from '@core/js/hooks/navigate';
import { useAppSelector, usePageSelector } from '@core/js/store/hooks';
import { storageService } from '@core/js/services/storage.service';

export const useNavigateToPopupBackgroundPage = () => {
    const navigate = useNavigate();
    const rootPage = useAppSelector(prop('rootPage'));
    const popupBackgroundPagePath = usePageSelector(prop('popupBackgroundPagePath'));

    /* TotalCasino changes */
    return useCallback((e, isOverlay) => {
        const isRegistrationPage = location.pathname.includes('register');
        const isKIRpage = document.querySelector('.kir');
        const popupBgPagePath = popupBackgroundPagePath === rootPage ? '/' : popupBackgroundPagePath;

        const preventLeavingRegistration = storageService.session.getItem('preventLeavingRegistration');

        if (isRegistrationPage && preventLeavingRegistration && !isOverlay) {
            return dispatcher.dispatch('registration:beforeClose');
        }

        isKIRpage
            ? navigate(popupBgPagePath || rootPage, null,
                { removeParams: ['SAMLart', 'RelayState', 'status', 'method'] })
            : navigate(popupBgPagePath || rootPage);
        dispatcher.dispatch('backButton:show');
    }, [popupBackgroundPagePath, rootPage, navigate]);
    /* TotalCasino changes */
};
